/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'blank': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: ''
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/blank.js